import { render } from "./Colorspace.vue?vue&type=template&id=29c32d20"
import script from "./Colorspace.vue?vue&type=script&lang=js"
export * from "./Colorspace.vue?vue&type=script&lang=js"

import "./Colorspace.vue?vue&type=style&index=0&id=29c32d20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__